import { QuestelServicesClient, HttpMethodEnum } from '@questelservices/common';
import store from '@/store';
import { PhaseTypeDto } from '@/models/PhaseTypeDto';
import { SelectOption } from '@/models/SelectOption';

export class PhaseTypeService {
  private readonly client: QuestelServicesClient;

  constructor() {
    this.client = new QuestelServicesClient(store, '/api/phasetype');
  }

  async getAll(): Promise<PhaseTypeDto[]> {
    return await this.client.get<PhaseTypeDto[]>('/all');
  }

  async getAllSelectOptions(includeAll: boolean = false): Promise<SelectOption[]> {
    let phaseTypes = await this.getAll();
    let result = phaseTypes.map<SelectOption>(p => {
      return { text: p.PhaseName, value: p.PhaseTypeId };
    });

    if (includeAll) {
      result.unshift({ text: 'ALL', value: '' });
    }

    return result;
  }

  async get(id: number): Promise<PhaseTypeDto> {
    return await this.client.get<PhaseTypeDto>(`/${id}`);
  }

  async create(data: PhaseTypeDto): Promise<PhaseTypeDto> {
    return await this.client.getPostData<PhaseTypeDto>('', data);
  }

  async update(id: number, data: PhaseTypeDto): Promise<PhaseTypeDto> {
    return await this.client.getData<PhaseTypeDto>(HttpMethodEnum.Put, `/${id}`, data);
  }

  async delete(id: number): Promise<PhaseTypeDto> {
    return await this.client.getData<PhaseTypeDto>(HttpMethodEnum.Delete, `/${id}`);
  }
}
